import { getProposal as getProposalApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetProposalServiceRequest, GetProposalServiceResponse } from './get-proposal.dto';
import {
  GetProposalServiceRequestSchema,
  GetProposalServiceResponseSchema,
} from './get-proposal.dto';

export const getProposalService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetProposalServiceRequestSchema),
    async (request: GetProposalServiceRequest): Promise<GetProposalServiceResponse> => {
      const apiResponse = await getProposalApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '캠페인 제안 상세 조회에 실패했습니다.');
      }

      return apiResponse.data;
    },
    validateServiceResponse(GetProposalServiceResponseSchema),
  ),
);
